// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***********************
* GLOBAL COLOR TOKENS * 
***********************/
.LogConsole-module__consoleLogContainer--dXGLG {
  width: 100%;
  margin-right: 0;
  margin-left: 0;
  position: absolute;
  bottom: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  padding: 0 0.5rem;
  background-color: #cbd5e1;
}

h2.LogConsole-module__consoleLogBanner--EQ7JQ {
  display: flex;
  width: 100%;
  height: var(--console-log-banner-height);
  padding: 0.5rem 0;
  justify-content: space-between;
  align-items: center;
  color: var(--console-log-text-color);
  font-family: "Roboto Flex";
  font-size: 14px;
  font-weight: 700;
}

.LogConsole-module__modeButtonsContainer--gy7br {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0.25rem;
}

button.LogConsole-module__consoleModeButton--neHYu {
  height: 2rem;
  display: flex;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  color: #0f172a;
  font-family: "Roboto Flex";
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.00875rem;
  background-color: var(--transparent);
}
button.LogConsole-module__consoleModeButton--neHYu.LogConsole-module__selectedMode--N4c72, button.LogConsole-module__consoleModeButton--neHYu.LogConsole-module__selectedMode--N4c72:hover:not(:disabled) {
  background-color: #ffffff;
  cursor: default;
}
button.LogConsole-module__consoleModeButton--neHYu:hover:not(:disabled) {
  background-color: rgba(39, 39, 42, 0.15);
}
button.LogConsole-module__consoleModeButton--neHYu:focus-visible {
  outline: 1px solid #1c4ed8;
  background-color: #fff;
}

.LogConsole-module__consoleLogOutput--fvqyh {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0.75rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 0.25rem;
  border-color: var(--console-log-output-background-color);
  outline: 2px solid var(--console-log-output-border-color);
  background: var(--console-log-output-background-color);
  resize: none; /* Remove resize handle */
  font-family: "Monaco", "Consolas", monospace;
  font-size: 14px;
}
.LogConsole-module__consoleLogOutput--fvqyh:focus {
  outline: none;
}

.LogConsole-module__buttonContainer--zKFJ8 {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
}

button.LogConsole-module__consoleLogButton--M7lxh {
  display: flex;
  width: 1.5rem;
  height: 1.5rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  border-radius: 0.25rem;
  border: 1px solid var(--console-log-button-border-color);
  background: var(--console-log-button-background-color);
  color: var(--console-log-text-color);
}
button.LogConsole-module__consoleLogButton--M7lxh:hover {
  border: 1px solid var(--console-log-button-hover-border-color);
  background: var(--console-log-button-hover-background-color);
}
button.LogConsole-module__consoleLogButton--M7lxh:focus-visible {
  outline: 1px solid #1c4ed8;
}`, "",{"version":3,"sources":["webpack://./src/_variables.scss","webpack://./src/components/Console/LogConsole.module.scss"],"names":[],"mappings":"AAAA;;uBAAA;ACEA;EAEC,WAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EAGA,iBAAA;EAEA,yBAAA;AAHD;;AAMA;EAEC,aAAA;EACA,WAAA;EACA,wCAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EAGA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AAND;;AASA;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;AAND;;AASA;EACC,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EAEA,oCAAA;AARD;AAUC;EAEC,yBAAA;EACA,eAAA;AATF;AAYC;EACC,wCAAA;AAVF;AAYC;EACC,0BAAA;EACA,sBAAA;AAVF;;AAcA;EAEC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;EAGA,sBAAA;EACA,wDAAA;EACA,yDAAA;EACA,sDAAA;EACA,YAAA,EAAA,yBAAA;EAGA,4CAAA;EACA,eAAA;AAhBD;AAkBC;EACC,aAAA;AAhBF;;AAoBA;EACC,aAAA;EACA,uBAAA;EACA,WAAA;AAjBD;;AAoBA;EAEC,aAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EAGA,sBAAA;EACA,wDAAA;EACA,sDAAA;EACA,oCAAA;AApBD;AAsBC;EACC,8DAAA;EACA,4DAAA;AApBF;AAsBC;EACC,0BAAA;AApBF","sourcesContent":["/***********************\n* GLOBAL COLOR TOKENS * \n***********************/\n$--neutral-00: #ffffff;\n$--neutral-50: #fafafa;\n$--neutral-100: #f4f4f5;\n$--neutral-200: #e4e4e7;\n$--neutral-300: #d4d4d8;\n$--neutral-400: #a1a1aa;\n$--neutral-500: #71717a;\n$--neutral-600: #52525b;\n$--neutral-700: #3f3f46;\n$--neutral-800: #27272a;\n$--neutral-900: #18181b;\n\n$--neutral-variant-00: #f8fafc;\n$--neutral-variant-50: #f1f5f9;\n$--neutral-variant-100: #e2e8f0;\n$--neutral-variant-200: #cbd5e1;\n$--neutral-variant-300: #b9c3d1;\n$--neutral-variant-400: #94a2b8;\n$--neutral-variant-500: #64738b;\n$--neutral-variant-600: #475569;\n$--neutral-variant-700: #334155;\n$--neutral-variant-800: #1e293b;\n$--neutral-variant-900: #0f172a;\n\n$--primary-00: #f7fbff;\n$--primary-50: #eff6ff;\n$--primary-100: #dbe9fe;\n$--primary-200: #bfdbfe;\n$--primary-300: #92c5fd;\n$--primary-400: #60a5fa;\n$--primary-500: #3c82f6;\n$--primary-600: #2463eb;\n$--primary-700: #1c4ed8;\n$--primary-800: #1d40ae;\n$--primary-900: #1f3a8a;\n\n$--secondary-00: #fcfffd;\n$--secondary-50: #ecfef6;\n$--secondary-100: #d1fae5;\n$--secondary-200: #a8f3d0;\n$--secondary-300: #6ee7b7;\n$--secondary-400: #34d399;\n$--secondary-500: #12b981;\n$--secondary-600: #079669;\n$--secondary-700: #047857;\n$--secondary-800: #076046;\n$--secondary-900: #064e3b;\n\n$--error-00: #fffdfd;\n$--error-50: #fef2f2;\n$--error-100: #fee2e1;\n$--error-200: #fecaca;\n$--error-300: #fda5a5;\n$--error-400: #f87171;\n$--error-500: #ef4444;\n$--error-600: #dc2625;\n$--error-700: #b91c1b;\n$--error-800: #991b1b;\n$--error-900: #7f1c1d;\n","@import \"../../variables\";\n\n.consoleLogContainer {\n\t// Layout\n\twidth: 100%;\n\tmargin-right: 0;\n\tmargin-left: 0;\n\tposition: absolute;\n\tbottom: 0;\n\tz-index: 2;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: flex-start;\n\tflex: 1 0 0;\n\talign-self: stretch;\n\n\t// Style\n\tpadding: 0 0.5rem;\n\n\tbackground-color: #{$--neutral-variant-200};\n}\n\nh2.consoleLogBanner {\n\t// Layout\n\tdisplay: flex;\n\twidth: 100%;\n\theight: var(--console-log-banner-height);\n\tpadding: 0.5rem 0;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\t// Typography\n\tcolor: var(--console-log-text-color);\n\tfont-family: \"Roboto Flex\";\n\tfont-size: 14px;\n\tfont-weight: 700;\n}\n\n.modeButtonsContainer {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tgap: 0.25rem;\n}\n\nbutton.consoleModeButton {\n\theight: 2rem;\n\tdisplay: flex;\n\tpadding: 0.5rem;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 0.25rem;\n\n\tcolor: #{$--neutral-variant-900};\n\tfont-family: \"Roboto Flex\";\n\tfont-size: 0.875rem;\n\tfont-weight: 400;\n\tletter-spacing: 0.00875rem;\n\n\tbackground-color: var(--transparent);\n\n\t&.selectedMode,\n\t&.selectedMode:hover:not(:disabled) {\n\t\tbackground-color: #{$--neutral-00};\n\t\tcursor: default;\n\t}\n\n\t&:hover:not(:disabled) {\n\t\tbackground-color: rgba(39, 39, 42, 0.15);\n\t}\n\t&:focus-visible {\n\t\toutline: 1px solid #{$--primary-700};\n\t\tbackground-color: #fff;\n\t}\n}\n\n.consoleLogOutput {\n\t// Layout\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 0.75rem;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 0.75rem;\n\tmargin-bottom: 0.5rem;\n\n\t// Style\n\tborder-radius: 0.25rem;\n\tborder-color: var(--console-log-output-background-color);\n\toutline: 2px solid var(--console-log-output-border-color);\n\tbackground: var(--console-log-output-background-color);\n\tresize: none; /* Remove resize handle */\n\n\t// Typography\n\tfont-family: \"Monaco\", \"Consolas\", monospace;\n\tfont-size: 14px;\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n\n.buttonContainer {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 0.5rem;\n}\n\nbutton.consoleLogButton {\n\t// Layout\n\tdisplay: flex;\n\twidth: 1.5rem;\n\theight: 1.5rem;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 0.625rem;\n\n\t// Style\n\tborder-radius: 0.25rem;\n\tborder: 1px solid var(--console-log-button-border-color);\n\tbackground: var(--console-log-button-background-color);\n\tcolor: var(--console-log-text-color);\n\n\t&:hover {\n\t\tborder: 1px solid var(--console-log-button-hover-border-color);\n\t\tbackground: var(--console-log-button-hover-background-color);\n\t}\n\t&:focus-visible {\n\t\toutline: 1px solid #{$--primary-700};\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"consoleLogContainer": `LogConsole-module__consoleLogContainer--dXGLG`,
	"consoleLogBanner": `LogConsole-module__consoleLogBanner--EQ7JQ`,
	"modeButtonsContainer": `LogConsole-module__modeButtonsContainer--gy7br`,
	"consoleModeButton": `LogConsole-module__consoleModeButton--neHYu`,
	"selectedMode": `LogConsole-module__selectedMode--N4c72`,
	"consoleLogOutput": `LogConsole-module__consoleLogOutput--fvqyh`,
	"buttonContainer": `LogConsole-module__buttonContainer--zKFJ8`,
	"consoleLogButton": `LogConsole-module__consoleLogButton--M7lxh`
};
export default ___CSS_LOADER_EXPORT___;
